<template>
<div>
  <div class="home" v-if="pcShow">
    <headerTitle indexInit="1"/>
    <carouselPics :pics="pics" carouselIndex="0"/>
    <div class="block_div"></div>
    <titleBlock textChinese="服务项目"  textEnglish="PROJECT  CLASSIFICATION"/>
    <div class="block_div"></div>
    <serviceBlockBuss /> 
    <div class="block_div"></div>
    <titleBlock textChinese="服务优势" textEnglish="OURS  ADVANCED"/>
    <div class="block_div"></div>
    <serviceAdvancedText />
     <div class="block_div"></div>
    <titleBlock textChinese="我们的服务" textEnglish="OURS SERVICES"/>
    <div class="block_div"></div>
    <ourService />
    
    <div class="block_div"></div>
    <titleBlock textChinese="服务花絮" textEnglish="SHOOTING GAGS"/>
    <div class="block_div"></div>
    <shooting />
    <div class="block_div"></div>
    <serviceProgress />

    <footerBlock />
  </div>
  <div v-if="!pcShow" class="wrap_mobile_business">
    <mobileHeader  indexInit="1"/>
      <mobileCarousel :pics="images" carouselIndex="0"/>
      <mobileDivBlock />
      <mobileTitleBlock textChinese="服务项目" flagIndex="1" textEnglish="PROJECT  CLASSIFICATION" />
      <mobileDivBlock />
      <mobileServiceBlockBuss />
      <mobileDivBlock />
      <mobileTitleBlock textChinese="服务优势" textEnglish="OURS  ADVANCED"/>
      <mobileDivBlock />
      <mobileDivBlock />
      <mobileserviceAdvancedText />
      <mobileTitleBlock textChinese="我们的服务" textEnglish="OURS SERVICES"/>
      <mobileDivBlock />
      <mobileourService />
      <mobileDivBlock />
      <mobileTitleBlock textChinese="服务花絮" textEnglish="SHOOTING GAGS"/>
      <mobileDivBlock />
      <mobileshooting />
      <mobileDivBlock />
      <mobileprogress />
      <mobileDivBlock />
      <mobilefooterBlock />

  </div>
  </div>
</template>

<script>
// @ is an alias to /src
import carouselPics from '@/components/carouselPics.vue'
import headerTitle from '@/components/headerTitle.vue'
import titleBlock from '@/components/titleBlock.vue'
import serviceBlockBuss from '@/components/serviceBlockBuss.vue'
// import videoBlock from '@/components/videoBlock.vue'
import serviceProgress from '@/components/serviceProgress.vue'
import ourService from '@/components/ourService.vue'
import footerBlock from '@/components/footerBlock.vue'
import serviceAdvancedText from '@/components/serviceAdvancedText.vue'
import shooting from '@/components/shooting.vue'
import mobileHeader from "@/components/mobileHeader.vue";
import mobileCarousel from "@/components/mobileCarousel.vue";
import mobileDivBlock from "@/components/mobileDivBlock.vue";
import mobileTitleBlock from "@/components/mobileTitleBlock.vue";
import mobileServiceBlockBuss from "@/components/mobileServiceBlockBuss.vue";
import mobileserviceAdvancedText from "@/components/mobileserviceAdvancedText.vue";
import mobileourService from "@/components/mobileourService.vue";
import mobileshooting from "@/components/mobileshooting.vue";
import mobileprogress from "@/components/mobileprogress.vue";
import mobilefooterBlock from "@/components/mobilefooterBlock.vue";








export default {
  name: 'business',
  data() {
    return {
      pics:[
        {url:require('@/assets/imgs/banner201.jpeg'),linerow:5,style:'text-align:right',text:'<span style="font-size:54px;color:#fff">敬畏客户的</span><span style="font-size:62px;color:#e91d62;padding-right:150px">每一分投入</span>'}, 
        {url:require('@/assets/imgs/banner202.jpeg'),linerow:5,style:'text-align:right',text:'<span style="font-size:62px;color:#e91d62">优质视频</span><span style="font-size:54px;color:#fff;padding-right:150px">内容创造者</span>'},
      ], 
      // videoArray:[
      //   [{url:require('@/assets/imgs/video01.jpeg'),text:'2020体彩竞猜广告-去赛场篇'},
      //   {url:require('@/assets/imgs/video02.jpeg'),text:'郎佳子彧的手工课'}],
      //   [{url:require('@/assets/imgs/video03.jpeg'),text:'2020体彩竞猜广告-去赛场篇'},
      //   {url:require('@/assets/imgs/video04.jpeg'),text:'郎佳子彧的手工课'}],
      //   [{url:require('@/assets/imgs/video05.jpeg'),text:'2020体彩竞猜广告-去赛场篇'},
      //   {url:require('@/assets/imgs/video06.jpeg'),text:'郎佳子彧的手工课'}],
      //   [{url:require('@/assets/imgs/video07.jpeg'),text:'2020体彩竞猜广告-去赛场篇'},
      //   {url:require('@/assets/imgs/video08.jpeg'),text:'郎佳子彧的手工课'}],
         
      // ],
      pcShow: false,
      images: [
        {url:require('@/assets/imgs/banner201.jpeg'),linerow:5,style:'text-align:right',text:'<span style="font-size:16px;color:#fff">敬畏客户的</span><span style="font-size:16px;color:#e91d62;padding-right:150px">每一分投入</span>'}, 
        {url:require('@/assets/imgs/banner202.jpeg'),linerow:5,style:'text-align:right',text:'<span style="font-size:16px;color:#e91d62">优质视频</span><span style="font-size:16px;color:#fff;padding-right:150px">内容创造者</span>'},
      ],
    }
  },
  components: {
    carouselPics,
    headerTitle,
    titleBlock,
    serviceBlockBuss,
    // videoBlock,
    serviceProgress,
    ourService,
    footerBlock,
    serviceAdvancedText,
    shooting,
    mobileHeader,
    mobileCarousel,
    mobileDivBlock,
    mobileTitleBlock,
    mobileServiceBlockBuss,
    mobileserviceAdvancedText,
    mobileourService,
    mobileshooting,
    mobileprogress,
    mobilefooterBlock
  },
  mounted() {
    this.widthChange();
window.addEventListener("resize", this.widthChange);
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },
  methods: {
    widthChange() {
      console.log(123333);
      let clientWidthW = document.body.clientWidth;
      console.log(this.pcShow, "999000this.pcShow");
      console.log(clientWidthW, "9900");
      if (clientWidthW < 768) {
        this.pcShow = false;
      } else {
        this.pcShow = true;
      }
    },
  }
}
</script>
<style lang="less">
  .wrap_mobile_business{
  div{
    overflow: hidden;
  }
}
</style>
